module.exports = __webpack_public_path__ + "img/background-cyan-darkblue.a96686b9.png";